module.exports = __webpack_public_path__ + "static/media/icon-how-it-works4.47a54283.svg";